export default __webpack_public_path__ + "static/improve-quality-of-life-accomplishment-6l-8b28b35a307d2fb9fab07afe3f51e4aa.webp";